const CopyIcon = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V4ZM5 15V5H15V15H5Z"
				fill="currentColor"
			/>
			<path
				d="M19 7V19H7V20.5C7 20.7761 7.22386 21 7.5 21H20C20.5523 21 21 20.5523 21 20V7.5C21 7.22386 20.7761 7 20.5 7H19Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export default CopyIcon
